<template>
  <el-drawer v-loading.fullscreen="loading" element-loading-text="数据提交中" :visible="visible" :wrapper-closable="false"
    size="75%" :destroy-on-close="true" @close="$emit('close')">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div>导入产品</div>
      <div>
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </div>
    <div class="list">
      <el-form ref="form" :rules="rules" :model="form" label-width="130px">
        <el-form-item label="物料分组" prop="materialGroupId">
          <el-cascader v-model="form.materialGroupId"
            :props="{ checkStrictly: true, children: 'children', label: 'materialGroupName', value: 'id' }"
            :options="categoryData" placeholder="请选择内容"></el-cascader>
        </el-form-item>
        <el-form-item required label="文件上传：">
          <el-upload ref="upload" accept=".xls,.xlsx" action="" :auto-upload="false" :show-file-list="false"
            class="upload-demo" :on-change="importData">
            <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
            <el-button type="text" size="small" style="margin-top: 4px; margin-left: 12px" @click="download">
              下载表格模版
            </el-button>
          </el-upload>
        </el-form-item>
        <div v-if="errorList.length > 0">
          <el-card header="错误提示">
            <template slot="header">
              <p class="red">
                <i class="el-icon-warning-outline"></i>
                导入失败！请根据错误提示，修改对应字段后重新导入。
              </p>
            </template>
            <p v-for="(item, index) in errorList" :key="index" class="m-2">
              {{ item }}
            </p>
          </el-card>
        </div>

        <div v-else-if="products.length > 0">
          <p class="green">
            <i class="el-icon-warning-outline" />
            成功读取到{{ products.length }}条数据，点击"提交"按钮进行保存
          </p>
        </div>
        <div v-if="importErrorInfo != ''">
          <p class="blue">
            导入异常信息:
            <span v-for="(item, index) of importErrorInfo" :key="index">
              {{ index + 1 }}:{{ item }}。 <br />
            </span>
          </p>
        </div>
      </el-form>
    </div>
  </el-drawer>
</template>
<script>
import XLSX from '@/assets/cdns/xlsx.js'
import { convertExcel } from '@/utils/importData'
import { getDownLoad } from '@/api/common/index'
import { importDataExcel, getMaterialCategory } from '@/api/material'
import { handleTree } from '@/utils/ruoyi.js'

export default {
  name: 'ImportMaterial',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      products: [],
      categoryData: [],
      form: {
        materialGroupId: []
      },
      rules: {
        materialGroupId: [
          {
            required: true,
            message: '请选择物料分组',
            trigger: ['change', 'blur']
          }
        ],
      },
      errorList: [],
      uploadFile: null,
      loading: false,
      importErrorInfo: [],
    }
  },
  created() {
    this.getMaterialCategory()
  },
  methods: {
    // 获取物料分组
    getMaterialCategory() {
      getMaterialCategory({}).then((res) => {
        this.categoryData = handleTree(res.data, 'materialGroupId', 'parentMaterialGroupId')
      })
    },
    async importData(file) {
      this.errorList = []
      this.packCheckList = []
      this.loading = true
      this.uploadFile = file
      const wookbook = await convertExcel(this.uploadFile.raw)
      console.log(wookbook);
      /* 解析产品及详情 */
      let products = XLSX.utils.sheet_to_json(wookbook.Sheets['物料信息'], {
        header: [
          'serial', // 序号
          'materialName', // 物料名称		规格型号
          'materialCode', // 物料编码
          'specification', // 规格型号
          'itemNo', // 货号
          'baseUnit', // 单位
          'storageTemperature', // 储存温度
          'listPrice', // 目录价
          'promotionPrice', // 促销价
          'time', // 有效期
          'unit', // 有效期单位
          'forbidStatus', // 是否禁用
        ]
      })
      // 从第5行开始解析
      products = products
        .slice(2)
        .map(
          ({
            serial, // 序号
            materialName, // 物料名称
            materialCode, // 物料编码
            specification, // 规格型号
            itemNo, // 货号
            baseUnit, // 单位
            storageTemperature, // 储存温度
            listPrice, // 目录价
            promotionPrice, // 促销价
            time, // 有效期
            unit, // 有效期单位
            forbidStatus, // 是否禁用
          }) => ({
            serial, // 序号
            materialName, // 物料名称		规格型号
            materialCode, // 物料编码
            specification, // 规格型号
            itemNo, // 货号
            baseUnit, // 单位
            storageTemperature, // 储存温度
            listPrice, // 目录价
            promotionPrice, // 促销价
            time, // 有效期
            unit, // 有效期单位
            forbidStatus, // 是否禁用
          })
        ).map((item => {
          return {
            ...item,
            forbidStatus: item.forbidStatus ? item.forbidStatus === '是' ? 'Y' : 'N' : null
          }
        }))

      // 校验包装层级，每个产品最多包含7层包装，
      products.forEach((product, index) => {
        // 必填校验
        const validOptions = [
          { key: 'serial', value: '序号' },
          { key: 'materialName', value: '物料名称' },
          { key: 'materialCode', value: '物料编码' },
          { key: 'specification', value: '规格型号' },
          { key: 'forbidStatus', value: '是否禁用' },
        ]
        const errors = this.customValidate(product, validOptions, '基本信息sheet页，')
        this.errorList = this.errorList.concat(errors)
        // 校验序号
        const serialError = this.customSerial(product.serial, index, '基本信息sheet页，')
        this.errorList = this.errorList.concat(serialError)
        // 正则校验包括数字或日期格式
        const regularOptions = []
        const regularError = this.checkRegular(product, regularOptions)
        this.errorList = this.errorList.concat(regularError)
      })

      if (this.errorList.length > 0) {
        this.loading = false
        return
      }
      this.loading = false
      this.products = products
    },
    // 校验长度是否符合标准,data表示检验的数据，message表示提示信息与字典中remark拼接而成
    checkNumber(data, message) {
      const keyList = Object.keys(data)
      keyList.forEach((key) => {
        const find = this.dicts.data_collection_info.find((item) => item.dictLabel == key)
        if (find && !!data[key] && String(data[key]).length > Number(find.dictValue)) {
          this.errorList.push(message + find.remark)
        }
      })
    },
    submit() {
      let { products } = this
      if (!this.uploadFile || this.uploadFile.length === 0) {
        this.$message({
          message: '请先上传文件！',
          type: 'warning'
        })
        return false
      }
      if (this.errorList && this.errorList.length > 0) {
        this.$message({
          message: '请修改对应的字段后重新导入后提交',
          type: 'warning'
        })
        return false
      }
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.loading = true
        products = products.map(item => {
          return {
            ...item,
            materialGroupId: this.form.materialGroupId[this.form.materialGroupId.length - 1],
          }
        })
        /* 保存 */
        importDataExcel(products)
          .then(({ code, msg }) => {
            if (Number(code) === 200) {
              this.$emit('close')
            } else {
              const list = msg.split('。')
              list.length -= 1
              list.forEach((item) => {
                this.errorList.push(item)
              })
            }
            this.uploadFile = null
          })
          .catch(() => {
            this.loading = false
          })
      })

    },
    download() {
      this.downloadLoading = true
      const elink = document.createElement('a') // 创建个a链接元素
      elink.href = 'https://udi-software.oss-cn-shenzhen.aliyuncs.com/saas-wms/%E7%89%A9%E6%96%99%E5%AF%BC%E5%85%A5.xlsx'
      elink.style.display = 'none'
      elink.setAttribute('download', '物料导入') // 文件名
      document.body.appendChild(elink)
      elink.click() // 触发点击方法
      URL.revokeObjectURL(elink.href) // 释放URL对象
      document.body.removeChild(elink) // 释放节点
      this.downloadLoading = false

      // const params = {
      //   filePath: 'templet/批量添加国际DI.xlsx'
      // }
      // getDownLoad(params)
      //   .then((res) => {
      //     const elink = document.createElement('a') // 创建个a链接元素
      //     elink.href = res.data
      //     elink.style.display = 'none'
      //     elink.setAttribute('download', '批量添加国际DI') // 文件名
      //     document.body.appendChild(elink)
      //     elink.click() // 触发点击方法
      //     URL.revokeObjectURL(elink.href) // 释放URL对象
      //     document.body.removeChild(elink) // 释放节点
      //     this.downloadLoading = false
      //   })
      //   .catch(() => {
      //     this.downloadLoading = false
      //   })
    }
  }
}
</script>

<style scoped lang="scss">
.file {
  padding: 0 8px;
  border-radius: 4px;
  display: inline-block;

  i {
    display: inline-block;
    width: 20px;
    color: #ccc;
  }

  &:hover {
    background-color: #f1f1f1;

    i {
      color: #333;
    }
  }
}
</style>
